<template>
    <div class="mpage">
        <div class="mpage_c">
            <div class="title">
                <div class="lef_p"><img src="@/assets/images/nav_head_bg1.png"></div>
                公司概况
                <div class="rig_P"><img src="@/assets/images/nav_head_bg2.png"></div>
            </div>
            <div class="mini_title">Company Overview</div>
            <div class="gsjj">
                <div class="gsjj_lef">
                    <div class="titlec">
                      苏州来吧科技有限公司
                    </div>
                    <div class="info">
                      苏州来吧科技有限公司专注于软件开发、网站建设、移动应用开发、人工智能等领域，为紧跟互联网发展和科技进步，
                      公司不断投入学习和开发成本，力求公司业务保持领先水平。公司经过长时间的经验积累，严格把控，目前正处于高速发展时期，
                      公司重视产品或服务的可扩展性，为了软件随着时代迁能够进化升级，在软件开发方面力求让软件系统能够支援后期发展，
                      有效预计未来趋势，预留可扩展可延申接口。 在网站建设方面，我司公众号、小程序、备案、数据库等等一系列的工作我们能够做到一条龙服务。
                      研发人员力求优化每一行代码，在可读性、效能性、稳定性、扩展性上做到万无一失，所有功能操作有日志可查，保持软件可持续性。
                    </div>
                </div>
                <div class="gsjj_rig">
                    <img src="@/assets/images/gs-pic.jpg">
                </div>
            </div>
          <div class="gsjj">
            <div class="laiba_rig">
              <img src="@/assets/images/laiba.png">
            </div>
            <div class="laiba_left">
              <div class="info">
                来吧助手产品简介： 来吧助手是苏州来吧科技有限公司研发的一款多平台、多账号全能工具。 它可以作为一款短视频社交平台,
                功能是为用户提供简单易用的短视频创作和分享体验，也可以作为一个应用下载平台，为用户提供多方面的移动APP下载服务。
                来吧助手致力于为用户提供丰富、优质、安全、个性化的安卓软件、视频资源。
              </div>
            </div>

          </div>
        </div>
    </div>
</template>

<script>
export default {
  created(){
    this.$emit('header', true);
    this.$emit('footer', true);
  }
}
</script>

<style scoped lang="less">
.gsjj{
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
    .gsjj_lef{
        text-align: left;
        width: 66%;
        .titlec{
            font-size: 26px;
            color: #333;
            font-weight: 800;
        }
        .info{
            margin-top: 20px;
            font-size: 20px;
            color: #999;
            line-height: 36px;
        }
    }
    .laiba_left{
        text-align: left;
        width: 85%;
        .titlec{
            font-size: 26px;
            color: #333;
            font-weight: 800;
        }
        .info{
            margin-top: 20px;
            font-size: 20px;
            color: #999;
            line-height: 36px;
        }
    }
    .gsjj_rig{
        margin-top: 10px;
        img{
            width: 360px;
            height: 236px;
        }
    }
    .laiba_rig{
        img{
            width: 200px;
            height: 200px;
        }
    }
}
.mpage {
    width: 100%;
    background: url('~@/assets/images/nl-bg1.png') no-repeat center top;
    background-size: 100% 100%;
    min-height: 862px;
    margin: 0 auto;
    text-align: center;

    .mpage_c {
        width: 1432px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 100px;

        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Microsoft YaHei;
            font-weight: 600;
            font-size: 32px;
            color: #282828;
            padding-top: 98px;

            .lef_p {
                margin-right: 50px;
            }

            .rig_P {
                margin-left: 50px;
            }
        }

        .mini_title {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 18px;
            color: #bcbcbc;
            margin-top: 6px;
            margin-bottom: 10px;
            text-transform:uppercase;
        }

        .power_list {
            display: flex;
            flex-wrap: wrap;

            .power_c {
                width: 477px;
                height: 430px;
                padding: 5px 47px 0px 50px;
                background: url('~@/assets/images/nl-bg2.png') no-repeat center top;
                background-size: 100% 100%;
                margin-bottom: 10px;

                .top {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 12px;
                    height: 113px;

                    .title_c {
                        text-align: left;
                        // padding-left: 10px;

                        .txt {
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            text-align: left;
                            padding-top: 52px;

                            .font_blue {
                                color: #4473EB;
                            }

                            .font_red {
                                color: #F67573;
                            }
                        }
                    }

                    .img1 {
                        width: 98px;
                        height: 82px;
                        margin-top: 24px;
                    }

                    .img2 {
                        width: 89px;
                        height: 68px;
                        margin-top: 24px;
                    }

                    .img3 {
                        width: 145px;
                        height: 105px;
                        margin-top: 8px;
                        margin-left: 50px;
                    }

                    .img4 {
                        width: 78px;
                        height: 85px;
                        margin-top: 24px;
                    }

                    .img5 {
                        width: 105px;
                        height: 91px;
                        margin-top: 24px;
                    }

                    .img6 {
                        width: 75px;
                        height: 76px;
                        margin-top: 24px;
                    }
                }
            }

            .info {
                text-align: left;

                .info_c {
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999;
                    line-height: 30px;
                    position: relative;

                    .font_blue {
                        color: #000;
                    }

                    .cir {
                        width: 6px;
                        height: 6px;
                        background: #4473EB;
                        border-radius: 50%;
                        position: absolute;
                        top: 13px;
                        left: 1px;
                    }

                    font {
                        width: 386px;
                        display: block;
                        text-indent: 2em;
                    }
                }
            }
        }
    }
}
</style>